import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { get, post } from '../../utils/request.js';

var getQuestionnaire = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var prefix,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prefix = _args.length > 1 && _args[1] !== undefined ? _args[1] : "/api";
            return _context.abrupt("return", get("".concat(prefix, "/questionnaire/subject"), {
              params: params
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getQuestionnaire(_x) {
    return _ref.apply(this, arguments);
  };
}();
var saveQuestionnaire = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    var prefix,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            prefix = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "/api";
            return _context2.abrupt("return", post("".concat(prefix, "/questionnaire/answer"), params));
          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function saveQuestionnaire(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

export { getQuestionnaire, saveQuestionnaire };
